import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import { skeletonBusyProps } from './skeletonCommon'

interface Props {
  readonly testId?: string
  readonly cards?: number
}

function ClaimedRewardCardSkeleton() {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '215px',
        bgcolor: '#fff',
        border: '1px solid #e8edf2',
        borderRadius: '16px',
        boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.05)',
        p: '18px',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ display: 'flex', gap: '12px', mb: '13px' }}>
        <Skeleton variant="rounded" width={36} height={36} sx={{ borderRadius: '8px' }} />
        <Skeleton variant="rounded" width="60%" height={24} sx={{ borderRadius: '6px' }} />
      </Box>
      <Box sx={{ display: 'flex', gap: '10px', mb: '13px' }}>
        <Skeleton variant="rounded" width={104} height={31} sx={{ borderRadius: '30px' }} />
        <Skeleton variant="rounded" width={64} height={31} sx={{ borderRadius: '20px' }} />
      </Box>
      <Skeleton variant="rounded" width="70%" height={20} sx={{ borderRadius: '6px', mb: 'auto' }} />
      <Skeleton
        variant="rounded"
        width={235}
        height={44}
        sx={{ borderRadius: '10px', alignSelf: 'center', mt: '16px' }}
      />
    </Box>
  )
}

export function ClaimedRewardsListSkeleton({
  testId = 'rewards-claimed-list-skeleton',
  cards = 6,
}: Readonly<Props>) {
  return (
    <Box data-testid={testId} {...skeletonBusyProps} aria-label="Loading claimed rewards">
      <Skeleton variant="rounded" width={160} height={28} sx={{ borderRadius: '6px', mb: '4px' }} />
      <Skeleton variant="rounded" width={120} height={16} sx={{ borderRadius: '6px', mb: '14px' }} />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'minmax(0, 1fr)',
            sm: 'repeat(2, minmax(0, 1fr))',
            md: 'repeat(3, minmax(0, 1fr))',
          },
          gap: '24px',
        }}
      >
        {Array.from({ length: cards }, (_, i) => (
          <ClaimedRewardCardSkeleton key={i} />
        ))}
      </Box>
    </Box>
  )
}
